/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import loadingConfig from "../config/loading.config.json";
import errorConfig from "../config/error.config.json";
import emptyConfig from "../config/empty.config.json";
import timelineConfig from "../config/timeline.config.json";
import provenanceDetailConfig from "../config/provenanceDetail.config.json";
import ageVerificaitonConfig from "../config/ageVerificationModal.config.json";
import feedbackFormConfig from "../config/feedback.config.json";

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  private getFeedbackConfig() {
    let _res = feedbackFormConfig;
    _res = {
      ..._res,
      fields: {
        ..._res?.fields,
        email: {
          ..._res?.fields?.email,
          validators: {
            ..._res?.fields?.email?.validators,
            regexp: {
              ..._res?.fields?.email?.validators?.regexp,
              //@ts-ignore
              regexp: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
            },
          },
        },
      },
    };
    return _res;
  }

  getProps(args: any) {
    return {
      loading: loadingConfig?.loading,
      empty: emptyConfig,
      error: errorConfig,
      timeline: timelineConfig,
      provenanceDetail: provenanceDetailConfig,
      ageVerificaiton: ageVerificaitonConfig,
      feedbackForm: this.getFeedbackConfig(),
    };
  }
}
